import { render, staticRenderFns } from "./CategoryGroups.vue?vue&type=template&id=573d5c27"
import script from "./CategoryGroups.vue?vue&type=script&lang=js"
export * from "./CategoryGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports